module.exports = __webpack_public_path__ + "img/shamrock-rovers-logo-icon.7927db1f.png";